/* eslint-disable */
// /src/services/appUpdatesService.js
// 역할:
//  - app_updates 컬렉션에서 최신 버전 정보 읽기
//  - 로컬 버전과 비교해서 필요하면 새로고침까지 처리

import { db } from "./firebase";
import {
    collection,
    getDocs,
    limit,
    orderBy,
    query,
} from "firebase/firestore";

// 관리자/에이전트와 동일한 컬렉션
const updatesCol = collection(db, "app_updates");

// 로컬에 저장하는 버전 키
export const APP_VERSION_KEY = "dhm.app.version";

/**
 * 버전 문자열 비교 helper
 *  - "1.0.3" vs "1.2.0" 같은 문자열 비교
 */
export function isVersionNewer(serverVersion, localVersion) {
    const sv = String(serverVersion || "")
        .split(".")
        .map((v) => parseInt(v, 10) || 0);
    const lv = String(localVersion || "")
        .split(".")
        .map((v) => parseInt(v, 10) || 0);

    const len = Math.max(sv.length, lv.length);

    for (let i = 0; i < len; i += 1) {
        const s = sv[i] ?? 0;
        const l = lv[i] ?? 0;
        if (s > l) return true;
        if (s < l) return false;
    }
    return false;
}

/**
 * 최신 app_updates 문서 하나 가져오기
 *  - createdAt 기준 최신 1개
 *  - 반환: { id, date, version, content, createdAt } 또는 null
 */
export async function fetchLatestAppUpdate() {
    const q = query(updatesCol, orderBy("createdAt", "desc"), limit(1));
    const snap = await getDocs(q);

    if (snap.empty) return null;

    const docSnap = snap.docs[0];
    const data = docSnap.data() || {};

    return {
        id: docSnap.id,
        date: data.date || "",
        version: data.version || "",
        content: data.content || "",
        createdAt: data.createdAt || null,
    };
}

/**
 * 버전 체크 + 자동 새로고침까지 한 번에 처리
 *
 * options:
 *  - onUpdateStart?: (boolean) => void   // "업데이트 중..." 표시용
 */
export async function checkAndApplyAppUpdate(options = {}) {
    const { onUpdateStart } = options;

    if (typeof window === "undefined") return;

    try {
        const latest = await fetchLatestAppUpdate();
        if (!latest || !latest.version) {
            console.warn("[appUpdatesService] no latest update or version");
            return;
        }

        const serverVersion = latest.version;
        const localVersion = window.localStorage.getItem(APP_VERSION_KEY);

        // 1) 로컬 버전이 없으면: 서버 버전만 기록하고 끝 (첫 실행)
        if (!localVersion) {
            console.log("[appUpdatesService] first version set", { serverVersion });
            try {
               ㅜsetItem(APP_VERSION_KEY, serverVersion);
            } catch (e) {
                console.warn(
                    "[appUpdatesService] failed to save first app version",
                    e
                );
            }
            return;
        }

        console.log("[appUpdatesService] compare versions", {
            localVersion,
            serverVersion,
        });

        // 2) 서버 버전이 더 크면 → 업데이트 처리
        if (isVersionNewer(serverVersion, localVersion)) {
            console.log("[appUpdatesService] version mismatch, will reload", {
                localVersion,
                serverVersion,
            });

            if (typeof onUpdateStart === "function") {
                onUpdateStart(true);
            }

            try {
                window.localStorage.setItem(APP_VERSION_KEY, serverVersion);
            } catch (e) {
                console.warn(
                    "[appUpdatesService] failed to update app version",
                    e
                );
            }

            setTimeout(() => {
                window.location.reload();
            }, 800);
        }
    } catch (e) {
        console.error("[appUpdatesService] app update check error", e);
    }
}
